module.exports = __webpack_public_path__ + "media/images/flags/64/Rwanda-ad0214b490a1a1fb64bae7c510749f08.png";